@for (option of sortOptions; track option.sortType) {
  <hq-sort-menu-option
    mat-ripple
    [sortOption]="option"
    [isSelected]="option.isSelected"
    [sortDirection]="option.sortDirection"
    (selectOption)="onSelectSortOption($event)">
  </hq-sort-menu-option>
}
